<script lang="ts" setup>
import { type PropType, ref, watch } from 'vue';
import { FormElement, useFormElement } from '@common';
import { LoadingCircular } from '@shared';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const { value, enabled, loading, onInput, onFocus, onBlur, needsReRender } = useFormElement(props.element);

const toggleKey = ref(0);

watch(needsReRender, () => {
  if (needsReRender.value) {
    toggleKey.value++;
    needsReRender.value = false;
  }
});

const select = (next: boolean, event: Event) => {
  if (!enabled.value || value.value === next) return;
  value.value = next;
  onInput(event as unknown as InputEvent);
};
</script>

<template>
  <div>
    <div class="d-flex align-center ga-3">
      <span
        :class="{ 'text-primary font-weight-medium': !value }"
        :style="enabled ? { cursor: 'pointer' } : undefined"
        @click="select(false, $event)">
        {{ $t('parcel.details.label.farmingModePrecision') }}
      </span>
      <v-switch
        v-model="value"
        :key="toggleKey"
        color="primary"
        :disabled="!enabled"
        hide-details
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur" />
      <span
        :class="{ 'text-primary font-weight-medium': value }"
        :style="enabled ? { cursor: 'pointer' } : undefined"
        @click="select(true, $event)">
        {{ $t('parcel.details.label.farmingModeTraditional') }}
      </span>
    </div>
    <loading-circular
      v-if="loading"
      color="primary"
      :size="28"
      class="mt-2" />
  </div>
</template>
